import React, {useMemo} from "react";
import classnames from "classnames";
import {Fade} from "@mui/material";
import {formatMoney} from "../../../../../../../../../core/services/utils/utils";
import LazyImage from "../../../../../../../../components/app-specific/lazy-image";
import UserWebHomepageTagsContainer from "../../../tags-container";
import {ProductTitleText} from "../../../../../../../../views/panel/operator/products/single";

const productTitleProps = {
    partNoClassName: 'part-no',
    maxLines: 2,
    titleClassName: 'product-card-title product-card-title--header',
    mainTextVariant: 'body1',
    showPartNoPopover: false,
};

const LargeUserWebHomepageProductCard = ({
                                             data,
                                             onClick,
                                             onTagClicked,
                                         }) => {
    const priceNotAvailable = useMemo(() => data?.changedPrice <= 0, [data]);
    const hasNewPrice = useMemo(() => data?.changedPrice < data?.originalPrice, [data]);
    const categoryTitle = data?.category?.title ?? data?.category?.Title ?? '';

    return (
        <>
            <div
                className={classnames('user-web-homepage-product large')}
                id={data.webViewElementId}
                onClick={onClick}
            >
                <div>
                    <div className={'product-header'}>
                        <div className={'product-header-line product-header-line--info'}>
                            <ProductTitleText
                                {...productTitleProps}
                                partNo={data?.partNumber ?? ''}
                                title={data?.title ?? ""}
                            />
                            {
                                !!categoryTitle &&
                                <p className={'category mt-2 product-card-category'} title={categoryTitle}>
                                    {categoryTitle}
                                </p>
                            }
                        </div>
                        <div className={'product-header-line product-header-line--price'}>
                            {
                                hasNewPrice &&
                                <Fade in={hasNewPrice}>
                                    <p className={'price new'}>
                                        {formatMoney(data?.changedPrice)}
                                    </p>
                                </Fade>
                            }
                            {
                                priceNotAvailable
                                    ? <p className={'price not-available'}/>
                                    : <p className={classnames('price', {'old': hasNewPrice})}>
                                        {formatMoney(data?.originalPrice ?? data?.changedPrice)}
                                    </p>
                            }
                        </div>
                    </div>
                    <div className={'product-body'}>
                        <div className={'image'}>
                            <LazyImage
                                src={data?.imageUrl}
                                alt={data?.partNumber}
                                onContextMenu={(e) => e.preventDefault()}
                                onDragStart={(e) => e.preventDefault()}
                                className={'disable-downloading-image'}
                            />
                        </div>
                    </div>
                    <UserWebHomepageTagsContainer
                        tags={data?.tags}
                        onTagClicked={onTagClicked}
                    />
                </div>
            </div>
        </>
    );
}


export default LargeUserWebHomepageProductCard;
